/* ####################### Template Version Const ########################### */
export const MOBILE_TEMPLATE_VERSION = 'Mobile';
export const DEFAULT_TEMPLATE_VERSION = 'Default';

/* ####################### PAGE LIST LABEL  ########################### */
export const HOME_PAGE = 'standard';
export const PRODUCT_LIST_PAGE = 'productsList';
export const PRODUCT_SHEET_PAGE = 'productSheet';
export const SEARCH_PAGE = 'searchPage';
export const CALL_API_AND_FRONT_DISPLAY_MODE = 'Call_API_And_Front_Display';
export const NOT_CALL_API_AND_NOT_FRONT_DISPLAY_MODE = 'Not_Call_API_And_Not_Front_Display';
export const NAVIGATION_PAGE = 'navigationPage';
export const REVIEWS_DISPLAY_THRESHOLD = 2;
export const DASHBOARD_PAGE = 'dashboard';
export const CATEGORIES_PAGE = 'categoriesPage';

/* ####################### PAGE CATEGORIES  ########################### */
export const FIRST_CATEGORY_LEVEL = 'niv1';
export const SECOND_CATEGORY_LEVEL = 'niv2';

/* ####################### PAGE CUSTOMER AREA  ########################### */
export const CUSTOMER_AREA_PAGE = 'customerArea';
export const DEFAULT_VALUE_TO_CONVERT_MINUTES_TO_MILLISECONDS = 1000;
export const CUSTOMER_PAGE = 'CustomerPage';
export const CUSTOMER_ACCOUNT_ORDERS_PAGE = 'CUSTOMER_ACCOUNT_ORDERS_PAGE';
export const CUSTOMER_ACCOUNT_ORDER_DETAILS_PAGE = 'CUSTOMER_ACCOUNT_ORDER_DETAILS_PAGE';
export const CUSTOMER_ACCOUNT_CHANGE_PASSWORD_PAGE = 'CUSTOMER_ACCOUNT_CHANGE_PASSWORD_PAGE';
export const CUSTOMER_ACCOUNT_SOCIAL_MEDIA = 'CUSTOMER_ACCOUNT_SOCIAL_MEDIA';
export const CUSTOMER_ACCOUNT_PROFIL_PAGE = 'CUSTOMER_ACCOUNT_PROFIL_PAGE';
export const CUSTOMER_ACCOUNT_NEWSLETTER_PAGE = 'CUSTOMER_ACCOUNT_NEWSLETTER_PAGE';
export const CUSTOMER_ACCOUNT_KITCHEN_PROJECTS_PAGE = 'CUSTOMER_ACCOUNT_KITCHEN_PROJECTS_PAGE';
export const CUSTOMER_ACCOUNT_TRACKING_ACTION = 'Page d\'accueil';

/* ####################### PAGE PLANNER  ########################### */
export const PLANNER_PAGE = 'planner';
export const KITCHEN_PROJECTS = 'Mes projets cuisine 3D';
export const KITCHEN_PROJECTS_TRACKING_ACTION = '3D planner cuisine_Page mes projets';

/* ####################### PAGE MESSAGE  ########################### */
export const MAX_FILE_SIZE = 10485760;
export const FAILURE_CONTEXTS = ['sellerMessageFailed', 'sellerIncidentFailed', 'sellerMessageWithFileFailed', 'sellerIncidentWithFileFailed', 'invoiceRequestFailed', 'operatorMessageFailed'];
export const SELLER_INCIDENT_CONTEXT = 'sellerIncident';
export const SELLER_WITH_INCIDENT_CONTEXT = 'sellerWithIncident';
export const SELLER_INCIDENT_WITH_FILE_CONTEXT = 'sellerIncidentWithFile';
export const OPERATOR_MESSAGE_CONTEXT = 'operatorMessage';
export const SELLER_MESSAGE_WITH_FILE_CONTEXT = 'sellerMessageWithFile';
export const SELLER_MESSAGE_CONTEXT = 'sellerMessage';
export const INCIDENT_OPEN = 'INCIDENT_OPEN';
export const ORDER_LINE_STATE_LIST = ["REFUSED", "CLOSED", "CANCELED", "WAITING_ACCEPTANCE", "WAITING_DEBIT_PAYMENT"];
export const SEND_MESSAGE_CONTENT = "sendMessageContent";


/* ####################### not lazy loading product Image number   ########################### */
export const NOT_LAZY_MAX_IMAGE_NUMBER = 7
export const FILTER_AVAILABILITY_SHOP_ID_LIST_CODE = 'AvailabilityShopIdList'
/* ####################### renderMode PREFLTER LABEL    ########################### */
export const RENDER_MODE_PREFELTER = "IsPrefilter"
export const FILTER_PRICE_CODE = "Prix de référence"
/* ####################### max number  PREFLTER showed value    ########################### */
export const MAX_NUMBER_PREFELTER = 5

/* ####################### PAGINATION Const  ########################### */
export const SEE_MORE_VALUE = 'seeMore'
export const SEE_PREVIOUS_VALUE = 'seePrevious'

/* ####################### Regex    ########################### */
export const PHONE_REGEX = /^0[6-7][0-9]{8}$/
export const NAME_REGEX = /^[A-Za-zàâçéèêëîïôûùüÿñæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\d' .-]*$/i
export const EMAIL_REGEX = /^(?:[a-z0-9!#$%&'*+\/=?^_'{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_'{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
export const STREET_ADDRESS_COMPLEMENT_REGEX = /^[A-Za-zàâçéèêëîïôûùüÿñæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\d,#'* .-]*$/i
export const CUSTOMER_ACCOUNT_MAX_NUMBER_ORDERS = 5
export const CUSTOMER_ACCOUNT_MAX_NUMBER_PROJECTS = 6

export const monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
export const CUSTOMER_ACCOUNT_BACKEND_MAX_NUMBER_ORDERS_DASHBOARD_PAGE = 4
export const CUSTOMER_ACCOUNT_FRONTEND_MAX_NUMBER_ORDERS_DASHBOARD_PAGE = 3
export const ORDER_SHIPPED_LABEL = 'SHIPPED'
export const WORD_TO_REPLACE_IN_HOSTNAME = 'fasterize'


/* ####################### MESSAGE    ########################### */
export const REQUIRED_FIELD_MESSAGE = 'Champ obligatoire.'
export const REQUIRED_FIELD_MESSAGE_CIVILITY = 'Veuillez sélectionner une civilité.'
export const INVALIDE_FIELD_MESSAGE = 'Champ invalide.'
export const INVALIDE_FIELD_MESSAGE_COMP_ADR = 'Merci de ne pas renseigner de caractères spéciaux.'
export const MAX_LENGTH_FIELD_MESSAGE = (maxlength) => "Veuillez ne pas saisir plus de " + maxlength + " chiffres."
export const MIN_LENGTH_FIELD_MESSAGE = (minlength) => "Votre numéro doit être composé de " + minlength + " chiffres"
export const INVALIDE_PHONE_MESSAGE = 'Numéro de téléphone invalide.'
export const USED_PHONE_MESSAGE = 'Numéro de téléphone existant.'
export const INVALIDE_EMAIL_MESSAGE = 'Adresse e-mail invalide.'
export const USED_EMAIL_MESSAGE = 'Adresse e-mail existante'
export const UPDATE_KITCHEN_PROJECT_ERROR_MESSAGE = 'Une erreur technique est survenue, le projet n\'a pas pu être modifié.'
export const DELETE_KITCHEN_PROJECT_ERROR_MESSAGE = 'Une erreur technique est survenue, le projet n\'a pas pu être supprimé.'
export const LOAD_KITCHEN_PROJECT_ERROR_MESSAGE = 'Une erreur technique est survenue. Veuillez réessayer ultérieurement.'

/* ####################### Group User Type  ########################### */
export const GROUP_USER_WEB_BY_TOKEN = 'WebByToken'
/* ####################### Espace perso couleur des status commande ########################### */
export const DEFAULT_TRACKING_STATUS_COLOR = 'Blue'
export const SUCCESS_FINAL_TRACKING_STATUS_COLOR = 'Green'
export const FAILED_FINAL_TRACKING_STATUS_COLOR = 'Orange'
export const CANCELATION_STATUS_LABEL = 'Annulé'

/* ####################### RDV STATUS ########################### */
export const IN_PREPARATION_STATUS_ID = 20
export const LATE_STATUS_ID = 45
